module.exports = __webpack_public_path__ + "media/images/icon-search-alternate-4e0c51cb51e3046158b3e3ecf64778ab.svg";